<template>
  <div
    v-show="isShowEmojiAnimation"
    class="frisbuy-emoji-animation"
    ref="container"
  ></div>
</template>

<style lang="scss">
@keyframes iconAnimation {
  0% {
    bottom: -10%;
  }
  100% {
    bottom: 50%;
    opacity: 0;
  }
}

.frisbuy-emoji-animation {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;

  pointer-events: none;

  .frisbuy-emoji-animation__icon {
    position: absolute;
    bottom: -10%;

    width: 45px;
    aspect-ratio: 1 / 1;

    opacity: 1;

    animation: iconAnimation 1.5s;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
  }
}
</style>

<script>
export default {
  props: {
    isShowEmojiAnimation: {
      type: Boolean,
      require: false,
      default: false,
    },

    emojiIconUrl: {
      type: String,
      require: true,
    },
  },

  data() {
    return {};
  },

  watch: {
    isShowEmojiAnimation(value) {
      if (value) {
        this.showAnimation();
      }
    },
  },

  methods: {
    showAnimation() {
      var wrapper = document.createElement("div");

      for (let i = 0; i < 10; i++) {
        var img = document.createElement("img");

        img.src = this.emojiIconUrl;

        img.style.left = `${Math.round(Math.random() * 95)}%`;
        img.style["animation-delay"] = `${Math.random()}s`;
        img.classList.add("frisbuy-emoji-animation__icon");
        wrapper.appendChild(img);
      }

      this.$refs.container.appendChild(wrapper);

      setTimeout(() => {
        if (this.$refs.container) {
          this.$refs.container.removeChild(wrapper);
        }
      }, 3000);
    },
  },
};
</script>
